module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-title-dc7c1d65bde800fee30260251728f3e5.png";